import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingParts': false,
  'partsList': [],
};

export const partsAssignmentInQualityAssuranceOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingParts': true,
    }),
    [ActionTypes.FETCHED_PARTS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingParts': false,
      'partsList': action.response.data,
    }),
    [ActionTypes.FETCHED_PARTS_AVAILABLE_FAILED]: (state, action) => ({
      ...state,
      'loadingParts': false,
      'partsList': [],
    }),
  })(state, action);
};
